<script setup lang="ts">
    // @ts-expect-error raison: lib externe mal typée
    import { defineExpose } from "vue";
    import { formatAmount } from '@/utils';
    import { computed, reactive, ref } from 'vue';

    const isOpened = ref(false);
    const errorMessage = ref('');
    const loading = ref(false);
    const itemInfos = reactive({
        numero: '',
        numero_masque: '',
        annee_expiration: '',
        mois_expiration: '',
    });
    const itemErrors = ref<any>({});
    
    async function open(dataRow: any) {
        Object.assign(itemInfos, dataRow.data);
        itemErrors.value = dataRow.errors || {};
        isOpened.value = true;
    }

    function close() {
        isOpened.value = false;
    }

    const errorsText = computed(() => {
        return Object.values(itemErrors.value).flat().join(' ');
    });

    defineExpose({ open, close });
</script>

<template>
    <custom-modal v-model:show="isOpened">
        <template #header>
            <h4 class="font-semibold">Informations compte</h4>
        </template>
        <div>
            <div v-if="errorsText" class="alert alert-danger mb-4">{{ errorsText }}</div>
            <h5 class="flex align-items-center gap-4 font-medium text-primary-color my-5">
                <img src="/icons/icon-info-perso.svg" class="size-base" alt="" />
                Informations Carte
            </h5>
            <div class="item-row" :class="{ error: itemErrors.numero }">
                <div class="label">Numéro</div>
                <div class="item-info">{{ itemInfos.numero || '-' }}</div>
            </div>
            <div class="item-row" :class="{ error: itemErrors.numero_masque }">
                <div class="label">Numéro Masqué</div>
                <div class="item-info">{{ itemInfos.numero_masque || '-' }}</div>
            </div>
            <div class="item-row" :class="{ error: itemErrors.annee_expiration }">
                <div class="label">Année expiration</div>
                <div class="item-info">{{ itemInfos.annee_expiration || '-' }}</div>
            </div>
            <div class="item-row" :class="{ error: itemErrors.mois_expiration }">
                <div class="label">Mois expiration</div>
                <div class="item-info">{{ itemInfos.mois_expiration || '-' }}</div>
            </div>
        </div>
        <template #footer>
            <button class="btn-ultra white2" style="justify-content: center;" @click="isOpened = false">Fermer</button>
        </template>
    </custom-modal>
</template>
